import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { submitLogoutFlow, useCreateLogoutFlow } from '@web-apps/feature-auth'
import { ROUTES } from '../../../routes/RouteEnums'
import { clearImpersonatedZezamId } from '../../../utils/helpers/impersonation.helpers'

export const LogoutPage = () => {
  const { token, isLoading, error } = useCreateLogoutFlow()

  useEffect(() => {
    localStorage.removeItem('isSeamlessAuth')
    clearImpersonatedZezamId()
    const logOut = async () => {
      await submitLogoutFlow({
        token,
      })

      window.location.href = ROUTES.LOGIN
    }

    if (error) {
      window.location.href = error.status === 401 ? ROUTES.LOGIN : ROUTES.LOGOUT
    }
    if (token) {
      logOut()
    }
  }, [token, error])

  if (!isLoading && !token) {
    return <Navigate replace to={ROUTES.LOGIN} />
  }

  return null
}
